import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Blog.css';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { blogAPI } from '../../api';

const BlogSection = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        try {
            setLoading(true);
            setError(null);
            
            console.log('Fetching public blogs...');
            const response = await blogAPI.getAll(1);
            
            console.log('Blog API Response (public):', response);
            
            if (response && response.success) {
                // Vérifier la structure exacte de la réponse
                console.log('Response structure:', {
                    hasData: !!response.data,
                    dataType: typeof response.data,
                    isArray: Array.isArray(response.data),
                    dataKeys: response.data ? Object.keys(response.data) : []
                });
                
                // La réponse peut avoir différentes structures
                let blogsData = [];
                
                if (Array.isArray(response.data)) {
                    // Si response.data est directement un tableau
                    blogsData = response.data;
                } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
                    // Si response.data a une propriété data qui est un tableau (pagination)
                    blogsData = response.data.data;
                } else if (response.data && Array.isArray(response.data)) {
                    // Autre cas
                    blogsData = response.data;
                }
                
                console.log('Blogs found:', blogsData.length);
                
                // Filtrer pour ne garder que les blogs publiés (sécurité supplémentaire)
                const publishedBlogs = blogsData.filter(blog => blog.is_published === true);
                console.log('Published blogs:', publishedBlogs.length);
                
                setBlogs(publishedBlogs);
            } else {
                console.warn('Invalid response structure:', response);
                setBlogs([]);
            }
        } catch (error) {
            console.error('Erreur détaillée lors du chargement des blogs:', error);
            setError(error.message || 'Erreur lors du chargement des articles');
            setBlogs([]);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'Date non spécifiée';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('fr-FR', { 
                year: 'numeric', 
                month: 'long', 
                day: 'numeric' 
            });
        } catch (e) {
            return 'Date non spécifiée';
        }
    };

    const truncateContent = (content, maxLength = 150) => {
        if (!content) return '';
        // Supprimer les balises HTML pour l'extrait
        const textContent = content.replace(/<[^>]*>/g, '');
        if (textContent.length <= maxLength) return textContent;
        return textContent.substring(0, maxLength) + '...';
    };

    const getBlogDetailUrl = (blog) => {
        return `/blog/${blog.slug || blog.id}`;
    };

    const getImageUrl = (blog) => {
        // Utiliser image_url créée par l'API ou fallback
        return blog.image_url || blog.image || '/default-blog.jpg';
    };

    const handleImageError = (e, blog) => {
        console.warn('Failed to load blog image:', blog?.title);
        e.target.onerror = null; // Éviter la boucle infinie
        
        // Créer un SVG de fallback
        const category = blog?.category || 'Blog ETEF';
        const title = blog?.title || 'Article';
        const truncatedTitle = title.length > 30 ? title.substring(0, 30) + '...' : title;
        
        const svgFallback = `
            <svg xmlns="http://www.w3.org/2000/svg" width="400" height="300" viewBox="0 0 400 300">
                <rect width="400" height="300" fill="#f8f9fa"/>
                <text x="200" y="140" font-family="Arial" font-size="20" text-anchor="middle" fill="#6c757d">
                    ${category}
                </text>
                <text x="200" y="170" font-family="Arial" font-size="14" text-anchor="middle" fill="#adb5bd">
                    ${truncatedTitle}
                </text>
            </svg>
        `;
        
        e.target.src = `data:image/svg+xml;utf8,${encodeURIComponent(svgFallback)}`;
    };

    // Fonction de débogage pour vérifier l'état des blogs
    const debugBlogs = () => {
        console.log('Current blogs state:', {
            count: blogs.length,
            blogs: blogs.map(b => ({ id: b.id, title: b.title, published: b.is_published }))
        });
    };

    // Appeler debugBlogs à chaque mise à jour
    useEffect(() => {
        debugBlogs();
    }, [blogs]);

    if (loading) {
        return (
            <div className="section-headerbigcontain">
                <Header />
                <section className="blog-section">
                    <div className="section-header">
                        <h2 className="section-title">Blog ETEF</h2>
                        <p className="section-subtitle">Dernières actualités</p>
                        <div className="header-divider"></div>
                    </div>
                    <div className="loading-container">
                        <div className="spinner"></div>
                        <p>Chargement des articles...</p>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }

    if (error) {
        return (
            <div className="section-headerbigcontain">
                <Header />
                <section className="blog-section">
                    <div className="section-header">
                        <h2 className="section-title">Blog ETEF</h2>
                        <p className="section-subtitle">Dernières actualités</p>
                        <div className="header-divider"></div>
                    </div>
                    <div className="error-container">
                        <svg width="60" height="60" viewBox="0 0 24 24" fill="#dc3545">
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                        </svg>
                        <h3>Une erreur est survenue</h3>
                        <p>{error}</p>
                        <button onClick={fetchBlogs} className="retry-button">
                            Réessayer
                        </button>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }

    return (
        <div className="section-headerbigcontain">
            <Header />
            <section className="blog-section">
                <div className="section-header">
                    <h2 className="section-title">Blog ETEF</h2>
                    <p className="section-subtitle">
                        Découvrez nos guides complets pour réussir vos études en France
                    </p>
                    <div className="header-divider"></div>
                </div>

                {blogs.length === 0 ? (
                    <div className="no-blogs-container">
                        <svg width="80" height="80" viewBox="0 0 24 24" fill="#6c757d">
                            <path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"/>
                        </svg>
                        <h3>Aucun article disponible pour le moment</h3>
                        <p>Revenez bientôt pour découvrir nos nouveaux articles !</p>
                        
                        {/* Bouton de débogage visible seulement en développement */}
                        {process.env.NODE_ENV === 'development' && (
                            <button 
                                onClick={fetchBlogs}
                                style={{
                                    marginTop: '20px',
                                    padding: '10px 20px',
                                    background: '#1e3c72',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer'
                                }}
                            >
                                Rafraîchir
                            </button>
                        )}
                    </div>
                ) : (
                    <>
                        <div className="blogs-grid">
                            {blogs.map(blog => (
                                <article key={blog.id} className="blog-card">
                                    <Link to={getBlogDetailUrl(blog)} className="blog-image-link">
                                        <div className="blog-image-container">
                                            <img 
                                                src={getImageUrl(blog)} 
                                                alt={blog.title}
                                                loading="lazy"
                                                className="blog-image"
                                                onError={(e) => handleImageError(e, blog)}
                                            />
                                            {blog.category && (
                                                <span className="blog-category">{blog.category}</span>
                                            )}
                                        </div>
                                    </Link>
                                    
                                    <div className="blog-content">
                                        <div className="blog-meta">
                                            <span className="blog-date">
                                                <svg className="meta-icon" viewBox="0 0 24 24" width="18" height="18">
                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
                                                </svg>
                                                {formatDate(blog.published_date || blog.created_at)}
                                            </span>
                                            {blog.author && (
                                                <span className="blog-author">
                                                    <svg className="meta-icon" viewBox="0 0 24 24" width="18" height="18">
                                                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                                    </svg>
                                                    {blog.author}
                                                </span>
                                            )}
                                        </div>
                                        
                                        <h3 className="blog-title">
                                            <Link to={getBlogDetailUrl(blog)} className="blog-title-link">
                                                {blog.title}
                                            </Link>
                                        </h3>
                                        
                                        <div className="blog-excerpt">
                                            {blog.excerpt || truncateContent(blog.content)}
                                        </div>
                                        
                                        <div className="blog-actions">
                                            <Link 
                                                to={getBlogDetailUrl(blog)} 
                                                className="read-more-btn"
                                            >
                                                <span>Lire la suite</span>
                                                <svg className="arrow-icon" viewBox="0 0 24 24" width="20" height="20">
                                                    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
                                                </svg>
                                            </Link>
                                        </div>
                                    </div>
                                </article>
                            ))}
                        </div>

                        {/* Indicateur du nombre de blogs (utile pour le débogage) */}
                        {process.env.NODE_ENV === 'development' && (
                            <div style={{ textAlign: 'center', marginTop: '20px', color: '#6c757d' }}>
                                {blogs.length} blog(s) publié(s) affiché(s)
                            </div>
                        )}
                    </>
                )}

                {/* Section CTA */}
                <div className="blog-cta">
                    <h3>Besoin d'un accompagnement personnalisé ?</h3>
                    <p>Contactez nos conseillers pour un bilan personnalisé de votre projet d'études en France.</p>
                    <Link to="/contact" className="cta-button">
                        Prendre rendez-vous
                    </Link>
                </div>
            </section>
            <Footer />
        </div>
    );
};

export default BlogSection;